// @flow
import { useContext } from 'react';

import { EstimateContext } from '../contexts/EstimateContext';
import { getIsNetNewCustomer } from '../components/credits-and-bursts/utils';

/**
 * Returns true if estimate is for a net new customer.
 * Use this hook to gate all SG CNBC related UI elements and logic.
 */
export const useIsSGCNBCApplicable = () => {
  const estimate = useContext(EstimateContext);
  const isNetNewCustomer = getIsNetNewCustomer(estimate);

  return isNetNewCustomer;
};
